import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { orderId } = useLocalSearchParams<{ orderId: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Gift Card Confirmation — {orderId}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
